import * as _4 from 'lodash4';
import * as moment from 'moment';
import { IActiveVisit } from '../types/appointment_interfaces';

export class CurrentUserAppointmentsServant {
  studentAppointmentSchedulingInfo(data: any) {
    const userData = data.user;
    const student = this._studentInfo(userData);
    const activeVisits = data.user.active_visits;
    return { ...this._studentAppointmentsInfo(userData), student, activeVisits: this._activeVisits(activeVisits) };
  }

  private _studentInfo(studentData: any) {
    const email = studentData.email;
    const cell_phone = studentData.cell_phone;
    return { email, cell_phone };
  }

  private _studentAppointmentsInfo(studentData: any) {
    const next_appointments = this._futureAppointmentsData(studentData);
    const past_appointments = this._pastAppointmentsData(studentData);
    const appointment_invitations = this._userAppointmentInvitations(studentData);
    return { next_appointments, past_appointments, appointment_invitations };
  }

  private _futureAppointmentsData(userData: any) {
    return this._userAppointmentsData(userData.upcoming_appointments);
  }
  private _pastAppointmentsData(userData: any) {
    return this._userAppointmentsData(userData.recent_appointments);
  }

  private _userAppointmentsData(appointmentsData: any) {
    return _4.map(appointmentsData, (appointment: any) => ({
      additional_details: appointment.details,
      appointment_id: appointment.event_id,
      appointment_type: appointment.recurrs ? 'Recurring Appointment' : 'One Time Appointment',
      attendees: appointment.attendees,
      calendar_instance_id: appointment.instance_id,
      comments: appointment.comments,
      end_timestamp: moment(appointment.end_time).unix(),
      is_cancelled: appointment.status === 'cancelled',
      location: { id: -1, name: appointment.location },
      organizers: appointment.staff,
      start_timestamp: moment(appointment.start_time).unix(),
      student_can_cancel: appointment.can_cancel,
      student_services: _4.map(_4.split(appointment.name), (service: any, key: number) => ({ id: key, name: service })),
      cancellation_lead_time_hours: appointment.cancellation_lead_time_hours,
      meeting_url_or_phone: appointment.meeting_url_or_phone,
      course: appointment.course,
      can_cancel: appointment.can_cancel,
      can_checkin: appointment.can_checkin,
      attendance_id: appointment.attendance_id
    }));
  }
  private _userAppointmentInvitations(userData: any) {
    return _4.map(userData.student_data.appointment_invitations, (invitation: any) => ({
      id: invitation.id,
      campaign_note: invitation.campaign_note,
      appointments_scheduled_so_far: invitation.total_uses,
      remaining_appointments_for_student: invitation.remaining_uses,
      creator: { id: invitation.creator.id, first_name: invitation.creator.name, last_name: '' },
      end_date: invitation.end_time,
      start_date: invitation.start_time,
      appointment_type: invitation.type,
      student_service: _4.head(invitation.services),
      service_category: undefined,
      location: invitation.location,
      organizers: _4.map(invitation.staff, (staff: any) => ({ id: staff.id, first_name: staff.name, last_name: '' }))
    }));
  }

  private _activeVisits(visits: any) {
    return _4.map(visits, (visit: IActiveVisit) => ({
      ...visit
    }));
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/servants/current_user_appointments_servant.ts